module.exports = __webpack_public_path__ + "img/1.eb81d663.jpg";